// Simple event bus using a dedicated EventTarget instance
const eventTarget = new window.EventTarget();

function on(eventName, handler) {
  if (typeof handler !== 'function') return () => {};
  const listener = (event) => handler(event.detail);
  eventTarget.addEventListener(eventName, listener);
  return () => eventTarget.removeEventListener(eventName, listener);
}

function off(eventName, handler) {
  eventTarget.removeEventListener(eventName, handler);
}

function emit(eventName, detail) {
  const evt = new window.CustomEvent(eventName, { detail });
  eventTarget.dispatchEvent(evt);
}

export default {
  on,
  off,
  emit,
};


